<section class="mt-section" :class="$style.uploader_component">  
  <div class="mt-group">
    <div :class="$style.uploader">
      <div :class="$style.nonUploadZone">
        <FontUploadIcon :class="$style.uploadZoneIcon" />
        <div :class="$style.uploadZoneTitleLive">
          {{$t('pages.submissions.components.upload.uploader.drag_zone.disable_subtitle')}}
        </div>
      </div>  
    </div>
  </div>
</section>